import React from "react";

// Wraps one admin page. A render-time crash shows the error and a reload button instead of a
// blank screen. It resets itself when the route changes (`resetKey`), so one broken page never
// takes the navigation down with it.
export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error(`app shell "${this.props.name || "app"}" crashed:`, error, info && info.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div data-testid="app-error" role="alert"
           style={{ background: "var(--hs-danger-subtle)", border: "1px solid var(--hs-danger)", borderRadius: 10, padding: 16, color: "var(--hs-text)" }}>
        <h3 style={{ marginTop: 0 }}>Something went wrong</h3>
        <pre data-testid="app-error-message" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: 12 }}>
          {String((error && error.message) || error)}
        </pre>
        <button data-testid="app-error-reload" onClick={() => window.location.reload()} className="hs-btn hs-btn-primary">
          Reload page
        </button>
      </div>
    );
  }
}

export default class AdminErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, key: props.resetKey };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.resetKey !== state.key) return { error: null, key: props.resetKey };
    return null;
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error(`admin page "${this.props.name}" crashed:`, error, info && info.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div data-testid="page-error" role="alert"
           style={{ background: "var(--hs-danger-subtle)", border: "1px solid var(--hs-danger)", borderRadius: 10, padding: 16, color: "var(--hs-text)" }}>
        <h3 style={{ marginTop: 0 }}>This page crashed{this.props.name ? `: ${this.props.name}` : ""}</h3>
        <pre data-testid="page-error-message" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: 12 }}>
          {String((error && error.message) || error)}
        </pre>
        <button data-testid="page-error-reload" onClick={() => window.location.reload()}
                className="hs-btn hs-btn-primary">
          Reload page
        </button>
      </div>
    );
  }
}
